import React from 'react'

const ChatHeader = () => {
    return (
        <div className='bg-bgColor-chat py-3 px-4 rounded-t-xl'>
            <div className='flex flex-row items-center'>
                <img src={'/assets/agents/charles-agent.svg'} className='object-contain w-[40px] !rounded-full mr-3'/>
                <p className='text-white'>Charles <span className='font-bold'>@HotelworldAI</span></p>
            </div>
        </div>
    )
}

export default ChatHeader;